// Kolom Information per delivery unit: Prompt (1) tampil apa adanya,
// Non-Prompt (2) ditampilkan sebagai SPOT.
// Toleran terhadap bentuk nilai angka (1/2) maupun label ('Prompt'/'Non-Prompt')
// dan casing Pascal/camel dari API.
export const resolveInformationPrompt = value => {
  if (value === null || value === undefined || value === '') return '-';
  const trimmed = String(value).trim().toUpperCase();
  const parsed = parseInt(value, 10);
  if (parsed === 1 || trimmed === 'PROMPT') return 'Prompt';
  if (parsed === 2 || trimmed === 'NON-PROMPT') return 'SPOT';
  return '-';
};
